<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M22 19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H9.0005C9.55251 2 10 2.44749 10 2.9995C10 3.55154 9.55254 3.99909 9.0005 3.9992L5 4C4.44772 4 4 4.44772 4 5V18.278L8.18627 12.4188C8.50017 11.9793 9.09949 11.8737 9.54124 12.159L9.64018 12.2318L14.785 16.518L16.1679 14.4453C16.4947 13.9552 17.1636 13.8585 17.6141 14.2106L17.7071 14.2929L20 16.585V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19ZM9.187 14.458L5.228 20H19C19.4289 20 19.7948 19.73 19.9368 19.3506L17.155 16.57L15.8321 18.5547C15.5243 19.0163 14.9063 19.1338 14.454 18.838L14.3598 18.7682L9.187 14.458ZM17 2C17.5523 2 18 2.44772 18 3V6H21C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H18V11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11V8H13C12.4477 8 12 7.55228 12 7C12 6.44772 12.4477 6 13 6H16V3C16 2.44772 16.4477 2 17 2ZM8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6Z"
    fill="currentColor"
  />
</svg>
